import { Shield } from 'lucide-react';

const privacySections = [
  {
    title: '1. Wie zijn wij?',
    paragraphs: [
      { label: 'Verwerkingsverantwoordelijke:', text: 'Dgitaal' },
      { label: 'Adres:', text: 'Gaston Crommenlaan 8, 9050 Gent, Belgie' },
      { label: 'E-mail:', href: 'mailto:hello@dgitaal.be', text: 'hello@dgitaal.be' },
      { label: 'Telefoon:', text: '+32 (0)470 41 66 75' },
      { label: 'Ondernemingsnummer:', text: 'BE 1002.587.545' },
    ],
  },
  {
    title: '2. Welke persoonsgegevens verwerken wij?',
    intro: 'Afhankelijk van hoe u onze diensten gebruikt, kunnen wij de volgende gegevens verzamelen:',
    groups: [
      {
        title: 'Contactformulier & Algemene Aanvragen',
        items: ['Naam en voornaam', 'E-mailadres', 'Telefoonnummer (optioneel)', 'Bedrijfsnaam (optioneel)', 'Bericht/vraag'],
      },
      {
        title: 'Sollicitaties',
        items: ['Naam en voornaam', 'E-mailadres', 'Telefoonnummer', 'Curriculum vitae (CV)', 'Motivatiebrief'],
      },
      {
        title: 'Support Aanvragen',
        items: ['Naam en contactgegevens', 'Beschrijving van het probleem', 'Bedrijfsgegevens (indien zakelijke klant)'],
      },
      {
        title: 'Website Gebruik',
        items: ['IP-adres', 'Browsertype en -versie', "Bezochte pagina's", 'Datum en tijd van bezoek', 'Cookie-voorkeuren'],
      },
    ],
  },
  {
    title: '3. Waarvoor gebruiken wij uw gegevens?',
    intro: 'Wij verwerken uw persoonsgegevens voor de volgende doeleinden:',
    numbered: [
      { label: 'Communicatie', text: 'Om te reageren op uw vragen, offerteaanvragen of supportverzoeken.' },
      { label: 'Dienstverlening', text: 'Om onze IT-diensten en -producten aan u te leveren en te beheren.' },
      { label: 'Recruitment', text: 'Om sollicitaties te verwerken en kandidaten te beoordelen.' },
      { label: 'Website Optimalisatie', text: 'Om onze website te verbeteren en gebruiksvriendelijker te maken.' },
      { label: 'Wettelijke Verplichtingen', text: 'Om te voldoen aan wettelijke verplichtingen (bijv. boekhouding).' },
    ],
  },
  {
    title: '4. Rechtsgrondslag',
    intro: 'Wij verwerken uw persoonsgegevens op basis van:',
    bullets: [
      { label: 'Uw toestemming:', text: 'bij het invullen van contactformulieren, sollicitaties' },
      { label: 'Uitvoering van een overeenkomst:', text: 'wanneer u klant bent' },
      { label: 'Wettelijke verplichting:', text: 'bijvoorbeeld voor boekhoudkundige doeleinden' },
      { label: 'Gerechtvaardigd belang:', text: 'voor website-analyse en beveiliging' },
    ],
  },
  {
    title: '5. Hoe lang bewaren wij uw gegevens?',
    intro: 'Wij bewaren uw persoonsgegevens niet langer dan noodzakelijk:',
    paragraphs: [
      { label: 'Contactformulieren:', text: 'Maximum 2 jaar na laatste contact' },
      { label: 'Sollicitaties:', text: 'Maximum 1 jaar na sollicitatieprocedure (tenzij anders overeengekomen)' },
      { label: 'Klantengegevens:', text: 'Gedurende de contractuele relatie + 7 jaar (wettelijk verplicht voor facturen)' },
      { label: 'Website logs:', text: 'Maximum 6 maanden' },
    ],
  },
  {
    title: '6. Cookies',
    paragraphs: [
      { text: 'Onze website gebruikt cookies om uw gebruikservaring te verbeteren. Cookies zijn kleine tekstbestanden die op uw apparaat worden opgeslagen.' },
    ],
    cookieItems: [
      { label: 'Functionele cookies:', text: 'Noodzakelijk voor de werking van de website' },
      { label: 'Analytische cookies:', text: 'Om te begrijpen hoe bezoekers de site gebruiken' },
      { label: 'Voorkeurscookies:', text: 'Om uw cookie-voorkeuren te onthouden' },
    ],
    outro: 'U kunt cookies beheren of verwijderen via uw browserinstellingen. Let op: het uitschakelen van cookies kan invloed hebben op de functionaliteit van onze website.',
  },
  {
    title: '7. Delen wij uw gegevens?',
    paragraphs: [
      { text: 'Wij verkopen uw persoonsgegevens nooit aan derden. Wij kunnen uw gegevens alleen delen met:' },
    ],
    bullets: [
      { label: 'Dienstverleners:', text: 'Zoals hostingproviders, e-mailservices (altijd met verwerkersovereenkomst)' },
      { label: 'Juridische autoriteiten:', text: 'Wanneer wij wettelijk verplicht zijn' },
      { label: 'Zakelijke partners:', text: 'Alleen met uw expliciete toestemming' },
    ],
    outro: 'Alle derde partijen waarmee wij samenwerken zijn contractueel verplicht om uw gegevens te beschermen volgens de AVG/GDPR.',
  },
  {
    title: '8. Hoe beveiligen wij uw gegevens?',
    intro: 'Wij nemen uw privacy serieus en treffen passende technische en organisatorische maatregelen:',
    list: [
      'SSL-encryptie voor alle datatransmissies',
      'Beveiligde servers met regelmatige updates',
      'Toegangsbeperking tot persoonsgegevens',
      'Regelmatige back-ups',
      'Monitoring en logging van toegang',
      'Medewerkers zijn gebonden aan geheimhouding',
    ],
  },
  {
    title: '9. Wat zijn uw rechten?',
    intro: 'Onder de AVG/GDPR heeft u de volgende rechten:',
    rights: [
      { title: 'Recht op inzage', text: 'U kunt vragen welke gegevens wij van u verwerken' },
      { title: 'Recht op rectificatie', text: 'U kunt onjuiste gegevens laten corrigeren' },
      { title: 'Recht op verwijdering', text: 'U kunt vragen uw gegevens te verwijderen' },
      { title: 'Recht op beperking', text: 'U kunt de verwerking laten beperken' },
      { title: 'Recht op overdraagbaarheid', text: 'U kunt uw gegevens in machinelesbaar formaat opvragen' },
      { title: 'Recht van bezwaar', text: 'U kunt bezwaar maken tegen bepaalde verwerkingen' },
    ],
    actionText: 'Hoe kunt u uw rechten uitoefenen?',
    actionEmailPrefix: 'Stuur een e-mail naar ',
    actionEmail: 'hello@dgitaal.be',
    actionEmailSuffix: ' met het onderwerp "Privacyverzoek". Wij reageren binnen 1 maand op uw verzoek.',
  },
  {
    title: '10. Klachten',
    paragraphs: [
      { text: 'Heeft u een klacht over hoe wij met uw persoonsgegevens omgaan? Neem dan eerst contact met ons op via ', linkText: 'hello@dgitaal.be', href: 'mailto:hello@dgitaal.be', suffix: '.' },
      { text: 'U heeft ook het recht om een klacht in te dienen bij de Belgische Gegevensbeschermingsautoriteit (GBA):' },
      { label: 'Gegevensbeschermingsautoriteit', text: '' },
      { text: 'Drukpersstraat 35, 1000 Brussel' },
      { text: 'Tel: +32 (0)2 274 48 00' },
      { text: 'E-mail: ', linkText: 'contact@apd-gba.be', href: 'mailto:contact@apd-gba.be' },
      { text: 'Website: ', linkText: 'www.gegevensbeschermingsautoriteit.be', href: 'https://www.gegevensbeschermingsautoriteit.be' },
    ],
  },
  {
    title: '11. Wijzigingen aan dit privacybeleid',
    paragraphs: [
      { text: 'Wij kunnen dit privacybeleid van tijd tot tijd aanpassen. De meest recente versie vindt u altijd op deze pagina. Belangrijke wijzigingen zullen wij duidelijk communiceren op onze website.' },
    ],
  },
];

function Paragraph({ item }) {
  return (
    <p>
      {item.label ? <strong>{item.label} </strong> : null}
      {item.text}
      {item.href ? (
        <a href={item.href} className="text-[#3d56a6] hover:underline">
          {item.linkText || item.text}
        </a>
      ) : null}
      {item.suffix || ''}
    </p>
  );
}

export default function Privacybeleid() {
  return (
    <div data-testid="privacybeleid-page">
      <section className="relative pt-40 pb-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #16224b 0%, #233a80 100%)' }}>
        <div className="dot-pattern absolute inset-0" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h1 className="text-white font-bold mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em' }}>Privacybeleid</h1>
          <p className="text-white/70">Laatst bijgewerkt: 9 mei 2026</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 article-content">
          <p>
            Bij Dgitaal respecteren wij uw privacy en doen wij er alles aan om uw persoonsgegevens te beschermen. Dit privacybeleid legt uit welke gegevens wij verzamelen, hoe wij deze gebruiken en welke rechten u heeft.
          </p>

          {privacySections.map((section) => (
            <div key={section.title} className="mb-10">
              <h2>{section.title}</h2>
              {section.intro ? <p>{section.intro}</p> : null}

              {section.paragraphs?.map((item, index) => (
                <Paragraph key={`${section.title}-${index}`} item={item} />
              ))}

              {section.groups?.map((group) => (
                <div key={group.title} className="mb-5">
                  <h3>{group.title}</h3>
                  <ul>
                    {group.items.map((item) => (
                      <li key={`${group.title}-${item}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}

              {section.numbered ? (
                <div className="not-prose space-y-4 my-6">
                  {section.numbered.map((item, index) => (
                    <div key={item.label} className="flex gap-4 rounded-[24px] border border-[#d9deea] bg-[#f8f9fd] p-5">
                      <div className="w-9 h-9 rounded-full bg-[#f2a100] text-white font-bold flex items-center justify-center flex-shrink-0">
                        {index + 1}
                      </div>
                      <div>
                        <p className="font-semibold text-[#16224b] mb-1">{item.label}</p>
                        <p className="m-0 text-[#5f667a] leading-7">{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}

              {section.bullets ? (
                <ul>
                  {section.bullets.map((item) => (
                    <li key={item.label}>
                      <strong>{item.label} </strong>
                      {item.text}
                    </li>
                  ))}
                </ul>
              ) : null}

              {section.cookieItems ? (
                <div className="mb-5">
                  <h3>Welke cookies gebruiken wij?</h3>
                  <ul>
                    {section.cookieItems.map((item) => (
                      <li key={item.label}>
                        <strong>{item.label} </strong>
                        {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {section.list ? (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}

              {section.rights ? (
                <div className="not-prose grid gap-4 md:grid-cols-2 my-6">
                  {section.rights.map((item) => (
                    <div key={item.title} className="rounded-[24px] border border-[#d9deea] p-5 bg-[#f8f9fd]">
                      <h3 className="text-[#16224b] text-lg font-semibold mb-2">{item.title}</h3>
                      <p className="m-0 text-[#5f667a] leading-7">{item.text}</p>
                    </div>
                  ))}
                </div>
              ) : null}

              {section.actionText ? <p>{section.actionText}</p> : null}
              {section.actionEmail ? (
                <p>
                  {section.actionEmailPrefix}
                  <a href={`mailto:${section.actionEmail}`} className="text-[#3d56a6] hover:underline">
                    {section.actionEmail}
                  </a>
                  {section.actionEmailSuffix}
                </p>
              ) : null}

              {section.outro ? <p>{section.outro}</p> : null}
            </div>
          ))}

          <div className="not-prose rounded-[32px] border border-[#d9deea] bg-[#f8f9fd] p-8">
            <h2 className="text-[#16224b] text-2xl font-bold mb-3">Vragen over privacy?</h2>
            <p className="text-[#5f667a] leading-7 mb-6">
              Heeft u vragen over dit privacybeleid of over hoe wij uw persoonsgegevens verwerken? Neem gerust contact met ons op.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="mailto:hello@dgitaal.be" className="btn-gradient">E-mail ons</a>
              <a href="tel:+32470416675" className="btn-secondary-outline">Bel ons</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}